import { StatColumn } from "@bridgesplit/ui";
import { useRewardsPointsBreakdownStats } from "app/components/common";

import { RewardsDailyPointsProps } from "./RewardsDailyPoints";

export function RewardsDailyPointsBreakdown(props: RewardsDailyPointsProps) {
    const { stats, isLoading } = useRewardsPointsBreakdownStats(props);

    return <StatColumn stats={stats} loading={isLoading} spacing={0.5} />;
}
